// extracted by mini-css-extract-plugin
export default {"resource":"Resource_resource__4TJIB","deselectButton":"Resource_deselectButton__49UO6"};